import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    { q: 'faq_q1', a: 'faq_a1' },
    { q: 'faq_q2', a: 'faq_a2' },
    { q: 'faq_q3', a: 'faq_a3' },
    { q: 'faq_q4', a: 'faq_a4' },
    { q: 'faq_q5', a: 'faq_a5' },
    { q: 'faq_q6', a: 'faq_a6' },
    { q: 'faq_q7', a: 'faq_a7' },
    { q: 'faq_q8', a: 'faq_a8' },
  ];

  return (
    <div className="max-w-3xl mx-auto space-y-3">
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
        >
          <button
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
            className="w-full flex items-center justify-between px-5 py-4 text-left"
          >
            <span className="font-medium text-foreground-800 text-sm md:text-base pr-4">
              {t(faq.q)}
            </span>
            <i
              className={`ri-add-line text-lg text-primary-500 flex-shrink-0 transition-transform duration-200 ${
                openIndex === index ? 'rotate-45' : ''
              }`}
            ></i>
          </button>
          {openIndex === index && (
            <div className="px-5 pb-4">
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(faq.a)}
              </p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}